import { render, staticRenderFns } from "./EditAnchorAccessPoints.vue?vue&type=template&id=0d8197e6&scoped=true"
import script from "./EditAnchorAccessPoints.vue?vue&type=script&lang=js"
export * from "./EditAnchorAccessPoints.vue?vue&type=script&lang=js"
import style0 from "./EditAnchorAccessPoints.vue?vue&type=style&index=0&id=0d8197e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8197e6",
  null
  
)

export default component.exports